import React from "react";
import PropTypes from "prop-types";
import WebinarsList from "./Webinars/List.jsx";
import Toolbar from "./Toolbar";
import Carts from "./Users/Carts";

const roles = [
  { value: "gp", label: "GP" },
  { value: "gp_trainee", label: "GP Trainee" },
  { value: "nurse", label: "Nurse" },
  { value: "consultant", label: "Consultant" },
  { value: "hospital_doctor", label: "NCHD (Hospital Doctor)" },
  { value: "nurse_specialist", label: "Nurse Specialist/ANP" },
  {
    value: "allied_healthcare_professional",
    label: "Allied Healthcare Professional",
  },
  { value: "practice_nurses_ipna_member", label: "IGPNEA Members" },
  { value: "pharmacist", label: "Pharmacy" },
  // { value: "midwifery", label: "Midwife" },
  // { value: "registered_general_nurses", label: "Registered General Nurse" },
];

function Dashboard({
  webinars,
  webinarsCount,
  paginationProps,
  filterProps,
  statistics,
  filters,
  showUsersModal,
}) {
  return (
    <div>
      <main className="site--width clearfix-c">
        <div className="container_statistics">
          <h3>Users statistics</h3>
          <div className="container_statistics_filter clearfix-c">
            {/*
            <div className="section_dropdown">
              <a className='dropdown-button btn' href='#' data-activates='dropdown1'>Registartion Date<span class="caret">▼</span></a>
            </div>
            <div className="section_dropdown">
              <a className='dropdown-button btn' href='#' data-activates='dropdown1'> Logged in from/to<span class="caret">▼</span></a>
            </div>
            <div className="section_dropdown">
              <a className='section_dropdown_button dropdown-button button_padding btn' href='#'> User Type</a>
            </div>
            <div className="section_dropdown">
              <a className='section_dropdown_button section_dropdown_button_active dropdown-button button_padding btn' href='#'> Country</a>
            </div>
            <div className="section_dropdown">
              <a className='section_dropdown_button section_dropdown_button_active dropdown-button button_padding btn' href='#'> Hospital</a>
            </div>
          */}
          </div>
          <Toolbar filterProps={{ ...filterProps, roles }} />
          <Carts
            {...{
              statistics,
              filters,
              roles,
            }}
          />
          {/*
            <div className="container_result">
              <p>Registered users</p>
              <p><span></span>total number</p>
            </div>
              <div className="container_result">
                <p>User Type</p>
                <p><span>76</span>GP trainee</p>
              </div>
              <div className="container_result">
                <p>Country</p>
                <p><span>50</span>Ireland</p>
              </div>
              <div className="container_result">
                <p>Hospital</p>
                <p><span>38</span>AMNCH Hospital</p>
              </div>
          */}
          <div className="container_result_statistic clearfix-c">
            <h5>Webinar statistics</h5>
            <h6>Total created webinars - {webinarsCount}</h6>
            <WebinarsList
              values={webinars}
              paginationProps={paginationProps}
              showUsersModal={showUsersModal}
            />
          </div>
        </div>
      </main>
    </div>
  );
}

Dashboard.defaultProps = {};

Dashboard.propTypes = {};

export default Dashboard;



// WEBPACK FOOTER //
// ./src/components/Admin/Statistics/Dashboard.jsx